export default __webpack_public_path__ + "static/media/cctv_activity_out.1903022c.svg";